/**
 * Checks if a symbol represents a crypto asset (BTC or ETH)
 * @param symbol - The trading symbol to check (e.g., "BTCUSD", "ETHUSD")
 * @returns true if the symbol contains BTC or ETH (case-insensitive), false otherwise
 */
export const isCryptoAsset = (symbol: string | undefined): boolean => {
  if (!symbol) {
    return false;
  }
  const upperSymbol = symbol.toUpperCase();
  return upperSymbol.includes('BTC') || upperSymbol.includes('ETH');
};
